import { buildUrl, handleResponse } from "./auth";

export const getAdminAudit = (params) => {
  const take = params?.take ? `?take=${params.take}` : "";
  return fetch(buildUrl(`/api/admin/audit${take}`), {
    credentials: "include",
  }).then(handleResponse);
};

const adminAuditApi = { getAdminAudit };

export default adminAuditApi;
